import React from "react";
import { Button } from "components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "components/ui/Popover";
import { ChevronDown, Trash2 } from "lucide-react";

function SavedSearchDropdown({
  open,
  setOpen,
  selected,
  setSelected,
  savedSearches,
  onRestore,
  onDeleteClick,
}) {
  if (!savedSearches.length) return null;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" className="flex-1 w-full justify-between">
          <span className="overflow-hidden w-[215px] text-start">
            {selected?.label || "Saved searches"}
          </span>
          <ChevronDown className="text-sm" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="min-w-[225px] w-full p-0 -translate-y-1">
        <div className="max-h-[300px] overflow-auto">
          {savedSearches.map((s) => (
            <div
              key={s.id}
              className="px-4 max-w-[270px] flex gap-2 items-center justify-between p-2 hover:bg-muted cursor-pointer"
              onClick={() => {
                setSelected({ value: s.id, label: s.title });
                onRestore(s.id);
              }}
            >
              <span>{s.title}</span>
              <button
                type="button"
                className="p-1 -m-1 rounded-full hover:bg-gray-300 transition"
                onClick={(e) => {
                  e.stopPropagation();
                  onDeleteClick(s);
                }}
              >
                <Trash2 size={20} strokeWidth={2.5} />
              </button>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}

export default SavedSearchDropdown;
